import {ConfigProps} from "antd/lib/notification";
import {Locale} from "../translations";
import {
    getFirstPathnameSegment,
    getSubDomain,
} from "./helpers/getFirstPathnameSegment";

// Typographic constants
export const THIN_SPACE = "\u2009";
export const NON_BREAKING_SPACE = "\u00A0";

export const DEFAULT_LOCALE: Locale = "de";
export const NOTIFICATION_DEFAULT_OPTIONS: ConfigProps = {
    duration: 0,
};

export const ORGANIZATION_ID = getFirstPathnameSegment();
export const SUBDOMAIN = getSubDomain();

// Letzten aufgerufenen Tenant merken, damit die oeffentliche Startseite (TopLevelPage)
// einen Login-Einstieg anbieten kann. In Produktion steht die Organization-ID im Pfad
// (/:orgId/...), auf der Startseite (/) fehlt sie – dann greifen wir auf diesen Wert zurueck.
export const LAST_ORGANIZATION_ID_KEY = "ko:lastOrganizationId";

if (ORGANIZATION_ID) {
    try {
        localStorage.setItem(LAST_ORGANIZATION_ID_KEY, ORGANIZATION_ID);
    } catch (e) {
        // localStorage kann in privaten Browser-Modi blockiert sein – die Merkfunktion
        // ist optional, daher bewusst kein Fehler.
    }
}

/** Liefert die zuletzt genutzte Organization-ID (falls vorhanden), sonst undefined. */
export const getLastOrganizationId = (): string | undefined => {
    try {
        return localStorage.getItem(LAST_ORGANIZATION_ID_KEY) || undefined;
    } catch (e) {
        return undefined;
    }
};
// export const STAGE = getSubDomain() === "stage"; // testing

// Phase 16 D-03: Retroaktiver Banner in Payment-Action-Timeline (AUDIT-02).
// Zeigt in der Drawer-Timeline unterhalb der Events den Hinweis
// "Keine Historie vor {PHASE_16_GO_LIVE_DATE}", damit Admin nicht falsche
// Schlüsse zieht (vor Go-Live existieren keine PaymentActionLog-Einträge).
// Finale Zahl wird vor Release angepasst.
export const PHASE_16_GO_LIVE_DATE = "15.05.2026";

// The env object contains constants that are only known during execution.
// Using an object so that it can be easily mocked from a test.
const env = {};

export default env;
